module.exports = __webpack_public_path__ + "static/img/data_empty.97a4bf21.png";